export const categoryMenuTypeEnum = {
    type1: 'Type1',
    type2: 'Type2',
    type3: 'Type3',
    type4: 'Type4',
    type5: 'Type5'
};